import type { Template } from "@/types";

export const SQ_06_H0_V6: Template[] = [
    {
        id: "sq-06-h0v6-01",
        name: "SQ 01 - H0V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h0_v6_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 110, y: 113, width: 329, height: 491, rotation: 0, imageRotation: 0 },
            { id: "2", x: 446, y: 113, width: 161, height: 242, rotation: 0, imageRotation: 0 },
            { id: "3", x: 446, y: 362, width: 161, height: 242, rotation: 0, imageRotation: 0 },
            { id: "4", x: 763, y: 50, width: 414, height: 617, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1184, y: 50, width: 204, height: 305, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1184, y: 362, width: 204, height: 305, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h0v6-02",
        name: "SQ 02 - H0V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h0_v6_02.png",
        size: [1434, 717],
        style: {},
        slots: [     
            { id: "1", x: 46, y: 50, width: 204, height: 305, rotation: 0, imageRotation: 0 },
            { id: "2", x: 46, y: 363, width: 204, height: 304, rotation: 0, imageRotation: 0 },
            { id: "3", x: 257, y: 50, width: 414, height: 617, rotation: 0, imageRotation: 0 },
            { id: "4", x: 827, y: 113, width: 329, height: 491, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1163, y: 113, width: 161, height: 242, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1163, y: 363, width: 161, height: 241, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h0v6-03",
        name: "SQ 03 - H0V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h0_v6_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 46, y: 50, width: 414, height: 617, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 467, y: 50, width: 204, height: 305, rotation: 0, imageRotation: 0 },
            { id: "3", x: 467, y: 363, width: 204, height: 304, rotation: 0, imageRotation: 0 },
            { id: "4", x: 762, y: 50, width: 414, height: 617, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1184, y: 50, width: 204, height: 305, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1184, y: 363, width: 204, height: 304, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h0v6-04",
        name: "SQ 04 - H0V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h0_v6_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 135, y: 141, width: 143, height: 214, rotation: 0, imageRotation: 0 },
            { id: "2", x: 135, y: 363, width: 143, height: 213, rotation: 0, imageRotation: 0 },
            { id: "3", x: 286, y: 141, width: 292, height: 435, rotation: 0, imageRotation: 0 },
            { id: "4", x: 855, y: 141, width: 292, height: 435, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1155, y: 141, width: 143, height: 214, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1155, y: 363, width: 143, height: 213, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h0v6-05",
        name: "SQ 05 - H0V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h0_v6_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 178, width: 233, height: 361, rotation: 0, imageRotation: 0 },
            { id: "2", x: 241, y: 178, width: 233, height: 361, rotation: 0, imageRotation: 0 },
            { id: "3", x: 482, y: 178, width: 233, height: 361, rotation: 0, imageRotation: 0 },
            { id: "4", x: 723, y: 178, width: 232, height: 361, rotation: 0, imageRotation: 0 },
            { id: "5", x: 963, y: 178, width: 232, height: 361, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1203, y: 178, width: 232, height: 361, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h0v6-06",
        name: "SQ 06 - H0V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h0_v6_06.png",
        size: [1434, 717],
        style: {},
        slots: [     
            { id: "1", x: 45, y: 205, width: 204, height: 307, rotation: 0, imageRotation: 0 },
            { id: "2", x: 257, y: 205, width: 204, height: 307, rotation: 0, imageRotation: 0 },
            { id: "3", x: 469, y: 205, width: 203, height: 307, rotation: 0, imageRotation: 0 },
            { id: "4", x: 762, y: 205, width: 204, height: 307, rotation: 0, imageRotation: 0 },
            { id: "5", x: 974, y: 205, width: 203, height: 307, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1185, y: 205, width: 203, height: 307, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-06-h0v6-07",
        name: "SQ 07 - H0V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h0_v6_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 67, y: 142, width: 287, height: 433, rotation: 0, imageRotation: 0 },
            { id: "2", x: 362, y: 142, width: 286, height: 433, rotation: 0, imageRotation: 0 },
            { id: "3", x: 812, y: 70, width: 392, height: 576, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1212, y: 70, width: 126, height: 187, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1212, y: 265, width: 126, height: 187, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1212, y: 460, width: 126, height: 186, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h0v6-08",
        name: "SQ 08 - H0V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h0_v6_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 74, y: 140, width: 135, height: 215, rotation: 0, imageRotation: 0 },
            { id: "2", x: 74, y: 362, width: 135, height: 215, rotation: 0, imageRotation: 0 },
            { id: "3", x: 216, y: 140, width: 285, height: 437, rotation: 0, imageRotation: 0 },
            { id: "4", x: 508, y: 140, width: 135, height: 215, rotation: 0, imageRotation: 0 },
            { id: "5", x: 508, y: 362, width: 135, height: 215, rotation: 0, imageRotation: 0 },
            { id: "6", x: 960, y: 0, width: 474, height: 717, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h0v6-09",
        name: "SQ 09 - H0V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h0_v6_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 463, height: 717, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 502, y: 39, width: 211, height: 316, rotation: 0, imageRotation: 0 },
            { id: "3", x: 502, y: 363, width: 211, height: 315, rotation: 0, imageRotation: 0 },
            { id: "4", x: 721, y: 39, width: 211, height: 316, rotation: 0, imageRotation: 0 },
            { id: "5", x: 721, y: 363, width: 211, height: 315, rotation: 0, imageRotation: 0 },
            { id: "6", x: 971, y: 0, width: 463, height: 717, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-06-h0v6-10",
        name: "SQ 10 - H0V6",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h0_v6_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 514, height: 717, rotation: 0, imageRotation: 0 },
            { id: "2", x: 790, y: 142, width: 281, height: 433, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1079, y: 142, width: 137, height: 213, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1079, y: 363, width: 137, height: 212, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1224, y: 142, width: 136, height: 213, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1224, y: 363, width: 136, height: 212, rotation: 0, imageRotation: 0 }
        ],
    },

];

